import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { Reveal } from "../../lib/reveal";
import ProjectCard from "../ProjectCard";

const HomeProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/projects")
      .then((res) => {
        const all = res.data || [];
        const featured = all.filter((p) => p.featured);
        setProjects((featured.length ? featured : all).slice(0, 4));
      })
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section data-testid="home-projects-section" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mb-14 flex flex-wrap items-end justify-between gap-6">
          <Reveal>
            <p className="mb-4 flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-bati-sky">
              <span className="h-px w-10 bg-bati-sky" /> Nos savoir-faire en images
            </p>
            <h2 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink sm:text-5xl">Nos réalisations</h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-bati-ink/55">
              Les projets ci-dessous illustrent les types de chantiers pris en charge par BÂTI 360. Les photographies de nos réalisations réelles seront intégrées prochainement.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <Link
              to="/realisations"
              data-testid="home-projects-all-link"
              className="group flex items-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-bati-blue transition-colors hover:text-bati-sky"
            >
              Voir tous les projets
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>

        {loading ? (
          <div className="grid gap-6 md:grid-cols-2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="aspect-[4/3] animate-pulse bg-bati-mist" />
            ))}
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2">
            {projects.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.08}>
                <ProjectCard project={p} />
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default HomeProjects;
